import React from 'react'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { StyleSheet, View, ViewProps } from 'react-native'
import { AccessType, useCompany } from 'zens-store'
import { Button, Text } from 'zens-storybook'
import { usePermissions } from '@dms/hook'

import { InfoBlock, InfoTable } from '..'

const styles = StyleSheet.create({
  container: {},
  info: {
    maxWidth: '100%',
  },
  skeletonRow: {
    height: 32,
  },
  skeletonTitle: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
})

interface Props extends ViewProps {
  companyId: number
}
const CompanyVitality = (props: Props) => {
  const { companyId, style, ...otherProps } = props
  const { t } = useTranslation()
  const company = useCompany({ companyId })
  const { vitalityTrigger } = company.data || {}
  const { hasPermission } = usePermissions(companyId)

  const config = {
    fields: [
      {
        label: t('Status'),
        value: vitalityTrigger ? t('Active') : t('Inactive'),
      },
    ],
  }

  return (
    <InfoTable
      title={t('Vitality trigger')}
      companyId={companyId}
      contentContainerStyle={styles.info}
      config={config}
      buttonTitle={t('Edit')}
      buttonHref={hasPermission(AccessType.Update, 'company') ? `/companies/${companyId}/vitality` : undefined}
      style={[styles.container, style]}
      {...otherProps}
    />
  )
}

interface SkeletonProps extends ViewProps {}
const Skeleton = (props: SkeletonProps) => {
  const { t } = useTranslation()
  return (
    <InfoBlock.Skeleton
      title={
        <View style={styles.skeletonTitle}>
          <Text level={4}>{t('Vitality trigger')}</Text>
          <Button.Skeleton />
        </View>
      }
      {...props}
    >
      <Text.Skeleton style={styles.skeletonRow} />
    </InfoBlock.Skeleton>
  )
}
CompanyVitality.Skeleton = Skeleton

export default observer(CompanyVitality)
